import { Card } from '@/components/ui/card';
import { Profile } from '@/types/profile';

interface ProfileBioCardProps {
  profile: Profile;
}

export function ProfileBioCard({ profile }: ProfileBioCardProps) {
  if (!profile.bio) return null;

  return (
    <Card className="bg-white/5 border-white/10 p-4">
      <h3 className="text-white font-medium text-sm mb-2">Sobre</h3>
      <p className="text-white/80 text-sm whitespace-pre-wrap">{profile.bio}</p>
    </Card>
  );
}
